'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var index = require('../../../../../../../node_modules/@radix-ui/react-dropdown-menu/dist/index.cjs');
var React = require('react');

/**
 * Subcomponent of DropdownMenu. Renders the trigger to open the dropdown menu.
 *
 * @scope: Web
 */ const Trigger = ({ children })=>{
    const ForwardedChild = /*#__PURE__*/ React.forwardRef((props, ref)=>/*#__PURE__*/ React.cloneElement(children, {
            ...props,
            innerRef: ref
        }));
    ForwardedChild.displayName = "ForwardedChild";
    return /*#__PURE__*/ jsxRuntime.jsx(index.Trigger, {
        asChild: true,
        children: /*#__PURE__*/ jsxRuntime.jsx(ForwardedChild, {})
    });
};
Trigger.displayName = "DropdownMenu.Trigger";

exports.Trigger = Trigger;
//# sourceMappingURL=Trigger.web.cjs.map
